/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tool_Detail_AttendeesInputs */

const es_chat_tool_detail_attendees = /** @type {(inputs: Chat_Tool_Detail_AttendeesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asistentes`)
};

const en_chat_tool_detail_attendees = /** @type {(inputs: Chat_Tool_Detail_AttendeesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attendees`)
};

/**
* | output |
* | --- |
* | "Attendees" |
*
* @param {Chat_Tool_Detail_AttendeesInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_tool_detail_attendees = /** @type {((inputs?: Chat_Tool_Detail_AttendeesInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Detail_AttendeesInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_tool_detail_attendees(inputs)
	return en_chat_tool_detail_attendees(inputs)
});
export { chat_tool_detail_attendees as "chat.tool_detail.attendees" }